import type { ReactNode } from 'react';

import type { TTestimonialsElement } from '@shared/dream-components';
import { TestimonialsElement } from '@shared/dream-components';

interface Props {
  node: TTestimonialsElement;
  children: ReactNode | ReactNode[];
}

const Testimonials = ({ node, children }: Props) => {
  return <TestimonialsElement element={node}>{children}</TestimonialsElement>;
};

export default Testimonials;
